import { action } from "satcheljs";

/**
 * triggers initialization of account
 */

interface TriggerReInitializeAccountActionMessage {
    userIdentity: string;
}
export const triggerReInitializeAccount: (userIdentity: string) => TriggerReInitializeAccountActionMessage = action("triggerReInitializeAccount", (userIdentity: string): TriggerReInitializeAccountActionMessage => ({ userIdentity }));
